import {DiscussionEmbed} from "disqus-react"
const DisqusComments = ({ postId }) => {
  const disqusShortname = "visionforisrael-1"
  const disqusConfig = {
    url: "https://www.visionforisrael.com",
    identifier: postId, // Single post id
    // title: post.title // Single post title
  }
  return (
    <div>
      <DiscussionEmbed
        shortname={disqusShortname}
        config={disqusConfig}
      />
    </div>
  )
}
export default DisqusComments;